import {Injectable, Injector} from "@angular/core";
import {EntityModel} from "@fedeltapointofsale/data-client";
import {DiscountData} from "./discount.data";

@Injectable()
export class DiscountEntityModel extends EntityModel<DiscountData> {

    constructor(injector: Injector) {
        super(injector, DiscountData);
    }
}
